import {logger, repType} from './index';

const hostNameMap: {[key: string]: string} = {
    iCafe: 'console.cloud.baidu-int.com/devops/icafe',
    iCode: 'console.cloud.baidu-int.com/devops/icode',
    iPipe: 'console.cloud.baidu-int.com/devops/ipipe',
    weiyun: 'weiyun.baidu-int.com',
    TDA: 'tda.baidu-int.com',
    OKR: 'okr.baidu-int.com',
    Family: 'family.baidu.com',
    Ku: 'ku.baidu-int.com',
};
const getName = (host: string) => {
    let result = 'other';
    Object.keys(hostNameMap).forEach((name) => {
        if (host.includes(hostNameMap[name])) {
            result = name;
        }
    });
    return result;
};

const repId = '80001.1.331';

let firstSpaNav = true;
export const logAssociations = ({docGuid, docCreateTime}: {docGuid: string, docCreateTime: string}) => {
    if ((window as any).isSdkPage) {
        return;
    }
    const referrer = document.referrer || '';
    const isFromKu = referrer.includes(location.host);
    if (referrer && !isFromKu && firstSpaNav) { // 一个文档页面只在硬打开时上报一次 后续不再上报
        firstSpaNav = false;
        const data = {
            docGuid,
            docCreateTime,
            actionType: 'trigger', // expose | trigger   expose 曝光时上报 trigger 用户操作或api调用时上报
            refType: 1, // 0 | 1 | 2 0表示文档引用外部系统，1表示外部系统引用文档，2表示进行了系统级打通关联
            refObj: {
                type: 'webSYS', // webSYS | IM | business | openAPI | webSDK
                link: referrer, // 对于webSYS，webSDK等能定位到链接的，需上报链接。
                name: getName(referrer), // 'other', // other | chat ｜ group | iCafe | meeting 详见上文
            },
            timeStamp: +new Date(),
        };
        logger(repId, repType.Click, data);
    }

};
